import { useEffect } from 'react';

const MetaTags = ({ title, description, imageUrl, url }) => {
    useEffect(() => {
        // Store original meta tags to restore them later
        const originalMeta = {};
        document.querySelectorAll('meta[data-dynamic="true"]').forEach(tag => {
            originalMeta[tag.getAttribute('property') || tag.getAttribute('name')] = tag.content;
            tag.remove();
        });

        // Create and set new meta tags
        const metaTags = [
            // Open Graph tags
            { property: 'og:title', content: title },
            { property: 'og:description', content: description },
            { property: 'og:image', content: imageUrl },
            { property: 'og:url', content: url },
            { property: 'og:type', content: 'website' },
            
            // Twitter Card tags
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: title },
            { name: 'twitter:description', content: description },
            { name: 'twitter:image', content: imageUrl },
            { name: 'twitter:url', content: url }
        ];

        // Add the meta tags to head
        metaTags.forEach(tagData => {
            const meta = document.createElement('meta');
            meta.setAttribute('data-dynamic', 'true');
            if (tagData.property) {
                meta.setAttribute('property', tagData.property);
            }
            if (tagData.name) {
                meta.setAttribute('name', tagData.name);
            }
            meta.content = tagData.content;
            document.head.appendChild(meta);
        });

        // Cleanup function to restore original meta tags when component unmounts
        return () => {
            document.querySelectorAll('meta[data-dynamic="true"]').forEach(tag => tag.remove());
            Object.entries(originalMeta).forEach(([key, content]) => {
                const meta = document.createElement('meta');
                meta.setAttribute(key.startsWith('og:') ? 'property' : 'name', key);
                meta.content = content;
                document.head.appendChild(meta);
            });
        };
    }, [title, description, imageUrl, url]);

    return null; // This is a utility component that doesn't render anything
};

export default MetaTags; 